import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-banqi',
  templateUrl: './banqi.component.html',
  styleUrls: ['./banqi.component.scss']
})
export class BanqiComponent {

  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 1024px)');

  constructor(
    private breakpointObserver: BreakpointObserver,
  ) { }


  @Input()
  show: boolean;

}
